/**
 * 客户余额
 *
 * @author FJJ
 * @version 1.0
 *
 * Copyright 2022, all rights reserved. Essa.cn
 * */

import React from 'react'
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import Lang from "@components/Lang/Lang";
import dayjs from "dayjs";
import AutoFetchTable from "@components/AutoFetchTable/AutoFetchTable";
import {isEmpty,symbolMoneyUtil} from '@utils/utils';
import { Link } from "react-router-dom";
import "./customerBalance.less";
class CustomerBalance extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            //加载中
            loading: true,
            // 列
            columns: [
                {
                    cnTitle: '时间',
                    cnTitleId: 'ShiJian',
                    width: 200,
                    fixed: "left",
                    dataIndex: 'happenTime',
                    render: (happenTime, record, index) => (
                        <div key={index}>
                            <p>{happenTime? dayjs(happenTime).format("YYYY-MM-DD HH:mm:ss"): "-"}</p>
                            {/*<p className={"con2-txt"}>ID<span className={"ml_4"}>{record.id}</span></p>*/}
                        </div>
                    ),
                },
                {
                    cnTitle: '客户',
                    cnTitleId: 'KeHu',
                    dataIndex: 'buyerCode',
                    render: (buyerName, record, index) => (
                        <Link className="num" to={`/financeManagement/customerBalanceDetail?id=${record.buyerId}`}>{record.buyerCode}</Link>
                    ),
                },
                {
                    cnTitle: '账户国家',
                    cnTitleId: 'ZhangHuGuoJia',
                    dataIndex: 'countryName',
                    render: (text, record, index) => {
                        const iconUrl = record.abbreviate?require('../../../assets/img/country/'+record.abbreviate + '.png'):"";
                        return (<span>{iconUrl?<img src={iconUrl.default} height={10.5} className={"mr_8"} />:null} {text}</span>)
                    },
                },
                {
                    cnTitle: '说明',
                    cnTitleId: 'ShuoMing',
                    dataIndex: 'remark',
                    width: 250,
                    render: (remark, record, index) => (<div className={"con2-txt"}>
                        {record.bizCode&&<span className={"mr_8"}>{record.bizCode}</span>}<span>{remark || "-"}</span>
                    </div>),
                },
                {
                    cnTitle: '状态',
                    cnTitleId: 'ZhuangTai',
                    dataIndex: 'inOutType',
                    render: (inOutType, record, index) => {
                        return (<div>{inOutType==1?<span className={"greedLabel"}>
                            <i className="ri-add-line"></i>
                            {Lang({id: 'Jia', default: '加'})}
                        </span>:(inOutType=='-1'?<span className={"redLabel"}>
                            <i className="ri-subtract-line"></i>
                            {Lang({id: 'Jian2', default: '减'})}
                        </span>:'')}</div>)
                    },
                },
                {
                    cnTitle: '收入',
                    cnTitleId: 'ShouRu',
                    dataIndex: 'marginAmount',
                    render: (marginAmount, record, index) => (
                        <span className={"fw_500 greenColor"}>{record.inOutType==1&&!isEmpty(record.marginAmount)?symbolMoneyUtil(record.marginAmount, record.currencySymbol):''}</span>
                    ),
                },
                {
                    cnTitle: '支出',
                    cnTitleId: 'ZhiChu',
                    dataIndex: 'marginAmount2',
                    render: (marginAmount2, record, index) => (
                        <span className={"fw_500 redColor"}>{record.inOutType=="-1"&&!isEmpty(record.marginAmount)?symbolMoneyUtil(record.marginAmount, record.currencySymbol):''}</span>
                    ),
                },
                {
                    cnTitle: '余额',
                    cnTitleId: 'YuE',
                    dataIndex: 'balanceAfter',
                    render: (balanceAfter, record, index) => (
                        <span className={"fw_500"}>{!isEmpty(record.balanceAfter)?symbolMoneyUtil(record.balanceAfter, record.currencySymbol):''}</span>
                    ),
                },
            ],
            searchFormOptions:[
                {
                    name:'inOutType',
                    cnTitle:'类型',
                    cnTitleId:'LeiXing',
                    cnPlaceholder:'请选择类型',
                    cnPlaceholderId:'QingXuanZeLeiXing',
                    type:'Enum',
                    // canSearch:true, // 选择搜索,
                    enumClass:'fin_in_out_type',
                    hiddenLabel:true,
                    enumCanAll:true,
                    width:150,
                    // excludeValue:['-10','110']
                },
                {
                    name:'keyword',
                    cnPlaceholder:'搜索客户编号',
                    cnPlaceholderId:'SouSuoKeHuBianHao',
                    hiddenLabel:true,
                    // type:'SearchInput'
                },
                {
                    name:'poCode',
                    cnPlaceholder:'请输入PO单号',
                    cnPlaceholderId:'QingShuRuPODanHao',
                    hiddenLabel:true,
                    // type:'SearchInput'
                },
                {
                    name:'time',
                    cnPlaceholder:[Lang({id:'KaiShiShiJian',default:'开始时间'}),Lang({id:'JieShuShiJian',default:'结束时间'})],
                    cnPlaceholderId:['KaiShiShiJian','JieShuShiJian'],
                    searchRange:['startTime','endTime'],
                    type:'DateRangePicker',
                    width:300,
                    hiddenLabel:true,
                    canSearch:false,
                },
            ],
        };
    }
    onRefTabOne = (ref) =>  this.onRefTabChildOne = ref;
    componentDidMount() {
    }
    render(){
        const { columns,searchFormOptions } = this.state;
        return (
            <>
                <CommonBreadcrumb
                    list={[
                        { name: Lang({id: 'KeHuZiJinMingXi', default: '客户资金明细'})}
                    ]}
                ></CommonBreadcrumb>
                <div className={"main-wrap customerBalanceWrap"}>
                    {/*<div className="mb_16 font-18 fw_700">{Lang({id: 'KeHuZiJinMingXi', default: '客户资金明细'})}</div>*/}
                    {/*表格*/}
                    <AutoFetchTable columns={columns}
                                    precondition={
                                        {
                                            inOutType:'', // 类型 默认为空
                                        }
                                    }
                                    exportSetting = {
                                        {
                                            exportUrl: '/data/bpms/jreport/mg/fexiao/fin/walletItem/print',
                                            exportTemplate: 'MgFenxiaoWelleItemReport',
                                            authName:'CustomerBalance-Export-Button'
                                        }
                                    }
                                    searchFormOptions={searchFormOptions}
                                    onRef={this.onRefTabOne}
                                    scroll={{ x: 1200 }}
                                    flagShowReset = {false}
                                    pageSize={50}
                                    fetchApi={'/service/mg/fin/ddp/wallet/item-list'}>
                    </AutoFetchTable>
                </div>
            </>
        )
    }
}

export default CustomerBalance;

